import { encodeRegExp, inBrowser } from './commonUtil';
import global from 'global';

// 修改 url 的参数, 在浏览器中, 不将search值作为参数传入时, 会直接修改浏览器的search值
export function set2search(key: string, val: string, locationSearch?: string) {
  const reg = new RegExp(`(^[?]?|&)(${encodeRegExp(key)})=([^&]*)(&|$)`);
  let search = locationSearch || global.location?.search || '';
  if (reg.test(search)) {
    search = search.replace(reg, `$1$2=${encodeURIComponent(val)}$4`);
  } else {
    search = `${search ? `${search}&` : '?'}${key}=${encodeURIComponent(val)}`;
  }
  search = search.replace(/^[?]*/, '?');
  if (inBrowser() && !locationSearch) history.replaceState(history.state, '', search);
  return search;
}

// 从 search 中获取参数
export function getFromSearch(key: string, search?: string): string {
  search = search || global.location?.search || '';
  const reg = new RegExp(`(^[?]?|&)${encodeRegExp(key)}=([^&]*)(&|$)`);
  const result = search.match(reg);
  if (result != null) {
    try {
      return decodeURIComponent(result[2] || '');
    } catch (e) {
      console.error(e);
      return result[2] || '';
    }
  }
  return '';
}

// 从 search 中清除某个参数
export function removeFromSearch(key: string, locationSearch?: string) {
  const reg = new RegExp(`(^[?]?|&)(${encodeRegExp(key)})=([^&]*)(?=&|$)`, 'g');
  let search = locationSearch || global.location?.search || '';
  if (!reg.test(search)) return search;
  search = search.replace(reg, '$1');
  // 移除重复的 & 符
  search = search.replace(/(^[?]?|&)&+/g, '$1');
  // 移除末尾的 & 符
  search = search.replace(/&+$/g, '');
  if (inBrowser() && !locationSearch) history.replaceState(history.state, '', search);
  return search;
}

// 从 search 中获取参数, 忽视参数大小写
export function getFromSearchIgnoreCase(key: string, search?: string): string {
  search = search || global.location?.search || '';
  const reg = new RegExp(`(^[?]?|&)${encodeRegExp(key)}=([^&]*)(&|$)`, 'i');
  const result = search.match(reg);
  if (result != null) {
    try {
      return decodeURIComponent(result[2] || '');
    } catch (e) {
      console.error(e);
      return result[2] || '';
    }
  }
  return '';
}

// 从 search 中清除某个参数, 忽视参数大小写
export function removeFromSearchIgnoreCase(key: string, locationSearch?: string) {
  const reg = new RegExp(`(^[?]?|&)(${encodeRegExp(key)})=([^&]*)(?=&|$)`, 'ig');
  let search = locationSearch || global.location?.search || '';
  if (!reg.test(search)) return search;
  search = search.replace(reg, '$1');
  // 移除重复的 & 符
  search = search.replace(/(^[?]?|&)&+/g, '$1');
  // 移除末尾的 & 符
  search = search.replace(/&+$/g, '');
  if (inBrowser() && !locationSearch) history.replaceState(history.state, '', search);
  return search;
}

// object 转 URL search 参数, 不包含首位的 ? 符, 属性值会进行 encode
export function obj2search(param = {}): string {
  return Object.keys(param).reduce((str, key) => {
    str += (str ? '&' : '') + `${key}=${encodeURIComponent(param[key])}`;
    return str;
  }, '');
}

// 从URL中获取获取所有参数
export function search2obj(locationSearch?: string): { [key: string]: string } {
  let search = locationSearch || global.location?.search || '';
  if (!search) return {};
  return search.split(/[?&]/).reduce((result, kv) => {
    if (kv) {
      const [k, ...v] = kv.split('=');
      try {
        result[k] = decodeURIComponent(v.join('='));
      } catch (e) {
        console.error(e);
        result[k] = v.join('=');
      }
    }
    return result;
  }, {});
}
